/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateDatevAccountDtoGen,
  MrfiktivImportDatevAccountDtoGen,
  MrfiktivMultipleIdsDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivPartnerDatevAccountControllerFindAllByPartnerIdParamsGen,
  MrfiktivPartnerDatevAccountViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class DatevAccount<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags DATEV Account
   * @name PartnerDatevAccountControllerCreate
   * @summary Create a new account
   * @request POST:/partner/{partnerId}/datev/account
   * @secure
   * @response `201` `MrfiktivPartnerDatevAccountViewModelGen` The account has been successfully created.
   */
  partnerDatevAccountControllerCreate = (
    partnerId: string,
    data: MrfiktivCreateDatevAccountDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerDatevAccountViewModelGen, any>({
      path: `/partner/${partnerId}/datev/account`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags DATEV Account
   * @name PartnerDatevAccountControllerFindAllByPartnerId
   * @summary Get all accounts for a partner
   * @request GET:/partner/{partnerId}/datev/account
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivPartnerDatevAccountViewModelGen)[] })`
   */
  partnerDatevAccountControllerFindAllByPartnerId = (
    { partnerId, ...query }: MrfiktivPartnerDatevAccountControllerFindAllByPartnerIdParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivPartnerDatevAccountViewModelGen[] }, any>({
      path: `/partner/${partnerId}/datev/account`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags DATEV Account
   * @name PartnerDatevAccountControllerReset
   * @summary Delete all accounts for partnerId
   * @request DELETE:/partner/{partnerId}/datev/account
   * @secure
   * @response `200` `void`
   */
  partnerDatevAccountControllerReset = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/partner/${partnerId}/datev/account`,
      method: "DELETE",
      secure: true,
      ...params
    });
  /**
   * No description
   *
   * @tags DATEV Account
   * @name PartnerDatevAccountControllerImport
   * @summary Create a new account
   * @request POST:/partner/{partnerId}/datev/account/import
   * @secure
   * @response `201` `(MrfiktivPartnerDatevAccountViewModelGen)[]` The accounts that have been successfully created.
   */
  partnerDatevAccountControllerImport = (
    partnerId: string,
    data: MrfiktivImportDatevAccountDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerDatevAccountViewModelGen[], any>({
      path: `/partner/${partnerId}/datev/account/import`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags DATEV Account
   * @name PartnerDatevAccountControllerGetMany
   * @summary (Account - READ) Get many accounts
   * @request POST:/partner/{partnerId}/datev/account/getByIds
   * @secure
   * @response `200` `(MrfiktivPartnerDatevAccountViewModelGen)[]` The accounts
   */
  partnerDatevAccountControllerGetMany = (
    partnerId: string,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerDatevAccountViewModelGen[], any>({
      path: `/partner/${partnerId}/datev/account/getByIds`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags DATEV Account
   * @name PartnerDatevAccountControllerFindOne
   * @summary Get a account by id
   * @request GET:/partner/{partnerId}/datev/account/{id}
   * @secure
   * @response `200` `MrfiktivPartnerDatevAccountViewModelGen` Returns the account.
   */
  partnerDatevAccountControllerFindOne = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivPartnerDatevAccountViewModelGen, any>({
      path: `/partner/${partnerId}/datev/account/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags DATEV Account
   * @name PartnerDatevAccountControllerSync
   * @summary Adds all accounts to documents for partnerId
   * @request POST:/partner/{partnerId}/datev/account/import/sync
   * @secure
   * @response `201` `void`
   */
  partnerDatevAccountControllerSync = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/partner/${partnerId}/datev/account/import/sync`,
      method: "POST",
      secure: true,
      ...params
    });
}
